import { create } from "zustand";

export const useChatNotifyCount=create((set)=>({
    chatNotifyCount: 0,
    setChatNotifyCount:(chatNotifyCount)=>set({chatNotifyCount}),
    decreaseChatNotifyCount  :()=>set((state)=>({
        chatNotifyCount: state.chatNotifyCount > 0 ? state.chatNotifyCount - 1 : 0
    })),
    increaseChatNotifyCount  :()=>set((state)=>({
        chatNotifyCount: state.chatNotifyCount + 1
    })),
    removeAllChatNotifyCount:()=>set({chatNotifyCount:0})
}))